module.exports = __webpack_public_path__ + "static/media/search.43f5d8e1.svg";